var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vm-info"},[_c('div',{staticClass:"vm-info__icon"},[_c('v-icon',{attrs:{"color":"#a9a9a9"}},[_vm._v("mdi-help-circle")])],1),_c('div',{staticClass:"vm-info__text"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }